import { Button } from "@novaescola/eva-react-v2/lib/Button";
import { Typography } from "@novaescola/eva-react-v2/lib/Typography";
import { StaticImage } from "gatsby-plugin-image";
import PropTypes from "prop-types";
import React, { useEffect, useRef } from "react";
import { useInView } from "../../hooks/useInView";

const LiteracyInFocus = () => {
  const literacyInFocusRef = useRef(null);

  const isInView = useInView(literacyInFocusRef);

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    const previewEventSent = window.dataLayer.filter(
      (el) =>
        el.label &&
        el.label ===
          "SITE: Click - Nova página de conteúdo - Alfabetização em Foco - bloco visualizado"
    );

    if (isInView && previewEventSent.length === 0) {
      window.dataLayer.push({
        event: "block_visualization",
        label:
          "SITE: Click - Nova página de conteúdo - Alfabetização em Foco - bloco visualizado",
      });
    }
  }, [isInView]);

  return (
    <div className="theme-block eva-card eva-bg-inst-50 eva-mb-06">
      <div className="eva-card-info">
        <Typography variant="title" size={6} asChild className="eva-mb-04">
          <p ref={literacyInFocusRef}>
            <i className="fa-regular fa-star eva-mr-03 eva-body-2"></i>
            Um novo aliado para Professores Alfabetizadores
          </p>
        </Typography>
        <StaticImage
          src="https://diagnostico.s3.amazonaws.com/ferramenta-sondagem.png"
          alt=""
          width={328}
          height={184}
          className="eva-mb-06"
        />
        <Typography variant="body" size={2} className="eva-mb-06">
        Acompanhe o progresso dos alunos durante o ano e otimize seu planejamento
        </Typography>
        <Button variant="outline-primary" size="medium" asChild>
          <a
            type="button"
            className="eva-btn-full eva-mt-02"
            href="https://novaescola.org.br/sala-do-professor/home?itm_source=site&itm_medium=banner&itm_campaign=jornalismo"
            data-track="SITE: Click - Nova página de conteúdo - Alfabetização em Foco - botão veja conteúdo"
          >
            ACESSAR AGORA
          </a>
        </Button>
      </div>
    </div>
  );
};

export default LiteracyInFocus;
